import { baseSeriesMark } from "../base/constant";

export const linkSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    group: {
        name: "group",
        type: "group"
    },
    link: {
        name: "link",
        type: "rule"
    },
    arrow: {
        name: "arrow",
        type: "symbol"
    }
});
//# sourceMappingURL=constant.js.map
